// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file src/protos/users/users.proto (syntax proto3)

import type { GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2';
import type { EmptySchema } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_empty } from '@bufbuild/protobuf/wkt';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file src/protos/users/users.proto.
 */
export const file_src_protos_users_users: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_google_protobuf_empty],
  );

/**
 * @generated from message CreateUserRequest
 */
export type CreateUserRequest = Message<'CreateUserRequest'> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string userName = 2;
   */
  userName?: string;

  /**
   * @generated from field: optional string phoneNumber = 3;
   */
  phoneNumber?: string;

  /**
   * @generated from field: string password = 4;
   */
  password: string;

  /**
   * @generated from field: optional string folio = 5;
   */
  folio?: string;
};

/**
 * Describes the message CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 0);

/**
 * @generated from message UserResponse
 */
export type UserResponse = Message<'UserResponse'> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional string details = 3;
   */
  details?: string;

  /**
   * @generated from field: optional string token = 4;
   */
  token?: string;

  /**
   * @generated from field: optional string refreshToken = 5;
   */
  refreshToken?: string;
};

/**
 * Describes the message UserResponse.
 * Use `create(UserResponseSchema)` to create a new message.
 */
export const UserResponseSchema: GenMessage<UserResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 1);

/**
 * @generated from message UserReply
 */
export type UserReply = Message<'UserReply'> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string concurrencyStamp = 4;
   */
  concurrencyStamp: string;
};

/**
 * Describes the message UserReply.
 * Use `create(UserReplySchema)` to create a new message.
 */
export const UserReplySchema: GenMessage<UserReply> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 2);

/**
 * @generated from message UserList
 */
export type UserList = Message<'UserList'> & {
  /**
   * @generated from field: repeated UserReply users = 1;
   */
  users: UserReply[];
};

/**
 * Describes the message UserList.
 * Use `create(UserListSchema)` to create a new message.
 */
export const UserListSchema: GenMessage<UserList> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 3);

/**
 * @generated from message mergeUsers
 */
export type mergeUsers = Message<'mergeUsers'> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string phoneNumber = 2;
   */
  phoneNumber?: string;
};

/**
 * Describes the message mergeUsers.
 * Use `create(mergeUsersSchema)` to create a new message.
 */
export const mergeUsersSchema: GenMessage<mergeUsers> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 4);

/**
 * @generated from message GetUserIdentifierRequest
 */
export type GetUserIdentifierRequest = Message<'GetUserIdentifierRequest'> & {
  /**
   * @generated from field: optional string username = 1;
   */
  username?: string;
};

/**
 * Describes the message GetUserIdentifierRequest.
 * Use `create(GetUserIdentifierRequestSchema)` to create a new message.
 */
export const GetUserIdentifierRequestSchema: GenMessage<GetUserIdentifierRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 5);

/**
 * @generated from message GetUserIdentifierResponse
 */
export type GetUserIdentifierResponse = Message<'GetUserIdentifierResponse'> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: optional string email = 3;
   */
  email?: string;

  /**
   * @generated from field: optional string phoneNumber = 4;
   */
  phoneNumber?: string;
};

/**
 * Describes the message GetUserIdentifierResponse.
 * Use `create(GetUserIdentifierResponseSchema)` to create a new message.
 */
export const GetUserIdentifierResponseSchema: GenMessage<GetUserIdentifierResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 6);

/**
 * @generated from message UpdateUserIdentifierRequest
 */
export type UpdateUserIdentifierRequest = Message<'UpdateUserIdentifierRequest'> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string phoneNumber = 2;
   */
  phoneNumber?: string;
};

/**
 * Describes the message UpdateUserIdentifierRequest.
 * Use `create(UpdateUserIdentifierRequestSchema)` to create a new message.
 */
export const UpdateUserIdentifierRequestSchema: GenMessage<UpdateUserIdentifierRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 7);

/**
 * @generated from message UpdateUserIdentifierResponse
 */
export type UpdateUserIdentifierResponse = Message<'UpdateUserIdentifierResponse'> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated string availableTwoFactorMethods = 3;
   */
  availableTwoFactorMethods: string[];
};

/**
 * Describes the message UpdateUserIdentifierResponse.
 * Use `create(UpdateUserIdentifierResponseSchema)` to create a new message.
 */
export const UpdateUserIdentifierResponseSchema: GenMessage<UpdateUserIdentifierResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 8);

/**
 * @generated from message AddProfileInfoRequest
 */
export type AddProfileInfoRequest = Message<'AddProfileInfoRequest'> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string lastName = 2;
   */
  lastName: string;

  /**
   * @generated from field: optional string secondLastName = 3;
   */
  secondLastName?: string;

  /**
   * @generated from field: optional string birthdate = 4;
   */
  birthdate?: string;

  /**
   * @generated from field: optional int32 genderId = 5;
   */
  genderId?: number;
};

/**
 * Describes the message AddProfileInfoRequest.
 * Use `create(AddProfileInfoRequestSchema)` to create a new message.
 */
export const AddProfileInfoRequestSchema: GenMessage<AddProfileInfoRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 9);

/**
 * @generated from message ProfileInfoDto
 */
export type ProfileInfoDto = Message<'ProfileInfoDto'> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string lastName = 2;
   */
  lastName: string;

  /**
   * @generated from field: optional string secondLastName = 3;
   */
  secondLastName?: string;

  /**
   * @generated from field: optional string urlProfileImage = 4;
   */
  urlProfileImage?: string;

  /**
   * @generated from field: optional string birthdate = 5;
   */
  birthdate?: string;

  /**
   * @generated from field: optional int32 genderId = 6;
   */
  genderId?: number;
};

/**
 * Describes the message ProfileInfoDto.
 * Use `create(ProfileInfoDtoSchema)` to create a new message.
 */
export const ProfileInfoDtoSchema: GenMessage<ProfileInfoDto> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 10);

/**
 * @generated from message UpdateProfileInfoRequest
 */
export type UpdateProfileInfoRequest = Message<'UpdateProfileInfoRequest'> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string lastName = 2;
   */
  lastName?: string;

  /**
   * @generated from field: optional string secondLastName = 3;
   */
  secondLastName?: string;

  /**
   * @generated from field: optional string birthdate = 4;
   */
  birthdate?: string;

  /**
   * @generated from field: optional int32 genderId = 5;
   */
  genderId?: number;
};

/**
 * Describes the message UpdateProfileInfoRequest.
 * Use `create(UpdateProfileInfoRequestSchema)` to create a new message.
 */
export const UpdateProfileInfoRequestSchema: GenMessage<UpdateProfileInfoRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 11);

/**
 * @generated from message GetProfileInfoRequest
 */
export type GetProfileInfoRequest = Message<'GetProfileInfoRequest'> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string phoneNumber = 2;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string username = 3;
   */
  username?: string;
};

/**
 * Describes the message GetProfileInfoRequest.
 * Use `create(GetProfileInfoRequestSchema)` to create a new message.
 */
export const GetProfileInfoRequestSchema: GenMessage<GetProfileInfoRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 12);

/**
 * @generated from message ProfileInfoResponse
 */
export type ProfileInfoResponse = Message<'ProfileInfoResponse'> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional ProfileInfoDto profileInfo = 3;
   */
  profileInfo?: ProfileInfoDto;
};

/**
 * Describes the message ProfileInfoResponse.
 * Use `create(ProfileInfoResponseSchema)` to create a new message.
 */
export const ProfileInfoResponseSchema: GenMessage<ProfileInfoResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 13);

/**
 * @generated from message AddressDto
 */
export type AddressDto = Message<'AddressDto'> & {
  /**
   * @generated from field: optional int32 countryId = 1;
   */
  countryId?: number;

  /**
   * @generated from field: optional int32 cityId = 2;
   */
  cityId?: number;

  /**
   * @generated from field: optional int32 admin1Id = 3;
   */
  admin1Id?: number;

  /**
   * @generated from field: optional int32 admin2Id = 4;
   */
  admin2Id?: number;

  /**
   * @generated from field: optional int32 localityId = 5;
   */
  localityId?: number;

  /**
   * @generated from field: optional int32 neighborhoodId = 6;
   */
  neighborhoodId?: number;

  /**
   * @generated from field: optional string street = 7;
   */
  street?: string;

  /**
   * @generated from field: optional string postalCode = 8;
   */
  postalCode?: string;

  /**
   * @generated from field: optional int32 externalNumber = 9;
   */
  externalNumber?: number;

  /**
   * @generated from field: optional int32 internalNumber = 10;
   */
  internalNumber?: number;

  /**
   * @generated from field: optional string homePhone = 11;
   */
  homePhone?: string;

  /**
   * @generated from field: bool isPrimary = 12;
   */
  isPrimary: boolean;

  /**
   * @generated from field: string type = 13;
   */
  type: string;
};

/**
 * Describes the message AddressDto.
 * Use `create(AddressDtoSchema)` to create a new message.
 */
export const AddressDtoSchema: GenMessage<AddressDto> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 14);

/**
 * @generated from message AddressRequest
 */
export type AddressRequest = Message<'AddressRequest'> & {
  /**
   * @generated from field: optional int32 countryId = 1;
   */
  countryId?: number;

  /**
   * @generated from field: optional int32 cityId = 2;
   */
  cityId?: number;

  /**
   * @generated from field: optional int32 admin1Id = 3;
   */
  admin1Id?: number;

  /**
   * @generated from field: optional int32 admin2Id = 4;
   */
  admin2Id?: number;

  /**
   * @generated from field: optional int32 localityId = 5;
   */
  localityId?: number;

  /**
   * @generated from field: optional int32 neighborhoodId = 6;
   */
  neighborhoodId?: number;

  /**
   * @generated from field: optional string street = 7;
   */
  street?: string;

  /**
   * @generated from field: optional string postalCode = 8;
   */
  postalCode?: string;

  /**
   * @generated from field: optional int32 externalNumber = 9;
   */
  externalNumber?: number;

  /**
   * @generated from field: optional int32 internalNumber = 10;
   */
  internalNumber?: number;

  /**
   * @generated from field: optional string homePhone = 11;
   */
  homePhone?: string;

  /**
   * @generated from field: optional bool isPrimary = 12;
   */
  isPrimary?: boolean;

  /**
   * @generated from field: optional string type = 13;
   */
  type?: string;
};

/**
 * Describes the message AddressRequest.
 * Use `create(AddressRequestSchema)` to create a new message.
 */
export const AddressRequestSchema: GenMessage<AddressRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 15);

/**
 * @generated from message AddressResponse
 */
export type AddressResponse = Message<'AddressResponse'> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: repeated AddressDto addresses = 3;
   */
  addresses: AddressDto[];
};

/**
 * Describes the message AddressResponse.
 * Use `create(AddressResponseSchema)` to create a new message.
 */
export const AddressResponseSchema: GenMessage<AddressResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 16);

/**
 * @generated from message DisplayAddressDto
 */
export type DisplayAddressDto = Message<'DisplayAddressDto'> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string address = 2;
   */
  address: string;
};

/**
 * Describes the message DisplayAddressDto.
 * Use `create(DisplayAddressDtoSchema)` to create a new message.
 */
export const DisplayAddressDtoSchema: GenMessage<DisplayAddressDto> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 17);

/**
 * @generated from message GetAddressesResponse
 */
export type GetAddressesResponse = Message<'GetAddressesResponse'> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: repeated AddressDto addresses = 3;
   */
  addresses: AddressDto[];

  /**
   * @generated from field: repeated DisplayAddressDto displayAddresses = 4;
   */
  displayAddresses: DisplayAddressDto[];
};

/**
 * Describes the message GetAddressesResponse.
 * Use `create(GetAddressesResponseSchema)` to create a new message.
 */
export const GetAddressesResponseSchema: GenMessage<GetAddressesResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 18);

/**
 * @generated from message UserEducationDto
 */
export type UserEducationDto = Message<'UserEducationDto'> & {
  /**
   * @generated from field: uint64 Id = 1;
   */
  Id: bigint;

  /**
   * @generated from field: uint64 userId = 2;
   */
  userId: bigint;

  /**
   * @generated from field: string institution = 3;
   */
  institution: string;

  /**
   * @generated from field: string degree = 4;
   */
  degree: string;

  /**
   * @generated from field: string fieldOfStudy = 5;
   */
  fieldOfStudy: string;

  /**
   * ISO 8601: "2025-01-10T00:00:00Z"
   *
   * @generated from field: string startDate = 6;
   */
  startDate: string;

  /**
   * @generated from field: string endDate = 7;
   */
  endDate: string;

  /**
   * @generated from field: bool hasProfessionalLicense = 8;
   */
  hasProfessionalLicense: boolean;
};

/**
 * Describes the message UserEducationDto.
 * Use `create(UserEducationDtoSchema)` to create a new message.
 */
export const UserEducationDtoSchema: GenMessage<UserEducationDto> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 19);

/**
 * @generated from message AddUserEducationRequest
 */
export type AddUserEducationRequest = Message<'AddUserEducationRequest'> & {
  /**
   * @generated from field: string institution = 1;
   */
  institution: string;

  /**
   * @generated from field: string degree = 2;
   */
  degree: string;

  /**
   * @generated from field: string fieldOfStudy = 3;
   */
  fieldOfStudy: string;

  /**
   * ISO 8601
   *
   * @generated from field: string startDate = 4;
   */
  startDate: string;

  /**
   * ISO 8601
   *
   * @generated from field: optional string endDate = 5;
   */
  endDate?: string;

  /**
   * @generated from field: bool hasProfessionalLicense = 6;
   */
  hasProfessionalLicense: boolean;
};

/**
 * Describes the message AddUserEducationRequest.
 * Use `create(AddUserEducationRequestSchema)` to create a new message.
 */
export const AddUserEducationRequestSchema: GenMessage<AddUserEducationRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 20);

/**
 * @generated from message UpdateUserEducationRequest
 */
export type UpdateUserEducationRequest = Message<'UpdateUserEducationRequest'> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string institution = 2;
   */
  institution?: string;

  /**
   * @generated from field: optional string degree = 3;
   */
  degree?: string;

  /**
   * @generated from field: optional string fieldOfStudy = 4;
   */
  fieldOfStudy?: string;

  /**
   * @generated from field: optional string startDate = 5;
   */
  startDate?: string;

  /**
   * @generated from field: optional string endDate = 6;
   */
  endDate?: string;

  /**
   * @generated from field: optional bool hasProfessionalLicense = 7;
   */
  hasProfessionalLicense?: boolean;
};

/**
 * Describes the message UpdateUserEducationRequest.
 * Use `create(UpdateUserEducationRequestSchema)` to create a new message.
 */
export const UpdateUserEducationRequestSchema: GenMessage<UpdateUserEducationRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 21);

/**
 * @generated from message DeleteUserEducationRequest
 */
export type DeleteUserEducationRequest = Message<'DeleteUserEducationRequest'> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message DeleteUserEducationRequest.
 * Use `create(DeleteUserEducationRequestSchema)` to create a new message.
 */
export const DeleteUserEducationRequestSchema: GenMessage<DeleteUserEducationRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 22);

/**
 * @generated from message UserEducationsRequest
 */
export type UserEducationsRequest = Message<'UserEducationsRequest'> & {
  /**
   * @generated from field: string userId = 1;
   */
  userId: string;
};

/**
 * Describes the message UserEducationsRequest.
 * Use `create(UserEducationsRequestSchema)` to create a new message.
 */
export const UserEducationsRequestSchema: GenMessage<UserEducationsRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 23);

/**
 * @generated from message UserEducationResponse
 */
export type UserEducationResponse = Message<'UserEducationResponse'> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: repeated UserEducationDto educations = 3;
   */
  educations: UserEducationDto[];
};

/**
 * Describes the message UserEducationResponse.
 * Use `create(UserEducationResponseSchema)` to create a new message.
 */
export const UserEducationResponseSchema: GenMessage<UserEducationResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 24);

/**
 * @generated from message GenericResponse
 */
export type GenericResponse = Message<'GenericResponse'> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message GenericResponse.
 * Use `create(GenericResponseSchema)` to create a new message.
 */
export const GenericResponseSchema: GenMessage<GenericResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 25);

/**
 * @generated from message UploadProfileImageRequest
 */
export type UploadProfileImageRequest = Message<'UploadProfileImageRequest'> & {
  /**
   * @generated from field: bytes image = 1;
   */
  image: Uint8Array;
};

/**
 * Describes the message UploadProfileImageRequest.
 * Use `create(UploadProfileImageRequestSchema)` to create a new message.
 */
export const UploadProfileImageRequestSchema: GenMessage<UploadProfileImageRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 26);

/**
 * @generated from message UploadProfileImageResponse
 */
export type UploadProfileImageResponse = Message<'UploadProfileImageResponse'> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string image_url = 2;
   */
  imageUrl: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message UploadProfileImageResponse.
 * Use `create(UploadProfileImageResponseSchema)` to create a new message.
 */
export const UploadProfileImageResponseSchema: GenMessage<UploadProfileImageResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 27);

/**
 * @generated from message AprendePersonRequest
 */
export type AprendePersonRequest = Message<'AprendePersonRequest'> & {
  /**
   * @generated from field: optional string Name = 1;
   */
  Name?: string;

  /**
   * @generated from field: optional string LastName = 2;
   */
  LastName?: string;

  /**
   * @generated from field: optional string MotherLastName = 3;
   */
  MotherLastName?: string;

  /**
   * @generated from field: optional int32 GenderId = 4;
   */
  GenderId?: number;

  /**
   * @generated from field: optional string Birthday = 5;
   */
  Birthday?: string;

  /**
   * @generated from field: optional string Facebook = 6;
   */
  Facebook?: string;

  /**
   * @generated from field: optional string Twitter = 7;
   */
  Twitter?: string;

  /**
   * @generated from field: optional string Instagram = 8;
   */
  Instagram?: string;

  /**
   * @generated from field: optional string Country = 9;
   */
  Country?: string;

  /**
   * @generated from field: optional int32 CityId = 10;
   */
  CityId?: number;

  /**
   * @generated from field: optional string Municipality = 11;
   */
  Municipality?: string;

  /**
   * @generated from field: optional string PostalCode = 12;
   */
  PostalCode?: string;

  /**
   * @generated from field: optional string Address1 = 13;
   */
  Address1?: string;

  /**
   * @generated from field: optional string Address2 = 14;
   */
  Address2?: string;

  /**
   * @generated from field: optional string HomePhoneNumber = 15;
   */
  HomePhoneNumber?: string;
};

/**
 * Describes the message AprendePersonRequest.
 * Use `create(AprendePersonRequestSchema)` to create a new message.
 */
export const AprendePersonRequestSchema: GenMessage<AprendePersonRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 28);

/**
 * @generated from message UserEmploymentDto
 */
export type UserEmploymentDto = Message<'UserEmploymentDto'> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: uint64 userId = 2;
   */
  userId: bigint;

  /**
   * @generated from field: string companyName = 3;
   */
  companyName: string;

  /**
   * @generated from field: string position = 4;
   */
  position: string;

  /**
   * @generated from field: string department = 5;
   */
  department: string;

  /**
   * @generated from field: string employmentTypeId = 6;
   */
  employmentTypeId: string;

  /**
   * @generated from field: optional string description = 7;
   */
  description?: string;

  /**
   * @generated from field: string startDate = 8;
   */
  startDate: string;

  /**
   * @generated from field: optional string endDate = 9;
   */
  endDate?: string;
};

/**
 * Describes the message UserEmploymentDto.
 * Use `create(UserEmploymentDtoSchema)` to create a new message.
 */
export const UserEmploymentDtoSchema: GenMessage<UserEmploymentDto> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 29);

/**
 * @generated from message AddUserEmploymentRequest
 */
export type AddUserEmploymentRequest = Message<'AddUserEmploymentRequest'> & {
  /**
   * @generated from field: string companyName = 1;
   */
  companyName: string;

  /**
   * @generated from field: string position = 2;
   */
  position: string;

  /**
   * @generated from field: string department = 3;
   */
  department: string;

  /**
   * @generated from field: int32 employmentTypeId = 4;
   */
  employmentTypeId: number;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: string startDate = 6;
   */
  startDate: string;

  /**
   * @generated from field: optional string endDate = 7;
   */
  endDate?: string;
};

/**
 * Describes the message AddUserEmploymentRequest.
 * Use `create(AddUserEmploymentRequestSchema)` to create a new message.
 */
export const AddUserEmploymentRequestSchema: GenMessage<AddUserEmploymentRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 30);

/**
 * @generated from message UpdateUserEmploymentRequest
 */
export type UpdateUserEmploymentRequest = Message<'UpdateUserEmploymentRequest'> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string companyName = 2;
   */
  companyName?: string;

  /**
   * @generated from field: optional string position = 3;
   */
  position?: string;

  /**
   * @generated from field: optional string department = 4;
   */
  department?: string;

  /**
   * @generated from field: optional string employmentTypeId = 5;
   */
  employmentTypeId?: string;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * @generated from field: optional string startDate = 7;
   */
  startDate?: string;

  /**
   * @generated from field: optional string endDate = 8;
   */
  endDate?: string;
};

/**
 * Describes the message UpdateUserEmploymentRequest.
 * Use `create(UpdateUserEmploymentRequestSchema)` to create a new message.
 */
export const UpdateUserEmploymentRequestSchema: GenMessage<UpdateUserEmploymentRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 31);

/**
 * @generated from message DeleteUserEmploymentRequest
 */
export type DeleteUserEmploymentRequest = Message<'DeleteUserEmploymentRequest'> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message DeleteUserEmploymentRequest.
 * Use `create(DeleteUserEmploymentRequestSchema)` to create a new message.
 */
export const DeleteUserEmploymentRequestSchema: GenMessage<DeleteUserEmploymentRequest> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 32);

/**
 * @generated from message UserEmploymentResponse
 */
export type UserEmploymentResponse = Message<'UserEmploymentResponse'> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: repeated UserEmploymentDto employments = 3;
   */
  employments: UserEmploymentDto[];
};

/**
 * Describes the message UserEmploymentResponse.
 * Use `create(UserEmploymentResponseSchema)` to create a new message.
 */
export const UserEmploymentResponseSchema: GenMessage<UserEmploymentResponse> =
  /*@__PURE__*/
  messageDesc(file_src_protos_users_users, 33);

/**
 * @generated from service UserData
 */
export const UserData: GenService<{
  /**
   * @generated from rpc UserData.GetAllUsers
   */
  getAllUsers: {
    methodKind: 'unary';
    input: typeof EmptySchema;
    output: typeof UserListSchema;
  };
  /**
   * @generated from rpc UserData.GetUserIdentifiers
   */
  getUserIdentifiers: {
    methodKind: 'unary';
    input: typeof GetUserIdentifierRequestSchema;
    output: typeof GetUserIdentifierResponseSchema;
  };
  /**
   * @generated from rpc UserData.CanUserUpdateIdentifier
   */
  canUserUpdateIdentifier: {
    methodKind: 'unary';
    input: typeof UpdateUserIdentifierRequestSchema;
    output: typeof UpdateUserIdentifierResponseSchema;
  };
  /**
   * @generated from rpc UserData.UpdateUserIdentifier
   */
  updateUserIdentifier: {
    methodKind: 'unary';
    input: typeof UpdateUserIdentifierRequestSchema;
    output: typeof UpdateUserIdentifierResponseSchema;
  };
  /**
   * @generated from rpc UserData.CreateUser
   */
  createUser: {
    methodKind: 'unary';
    input: typeof CreateUserRequestSchema;
    output: typeof UserResponseSchema;
  };
  /**
   * @generated from rpc UserData.DeleteUser
   */
  deleteUser: {
    methodKind: 'unary';
    input: typeof EmptySchema;
    output: typeof UserResponseSchema;
  };
  /**
   * @generated from rpc UserData.AddProfileInfo
   */
  addProfileInfo: {
    methodKind: 'unary';
    input: typeof AddProfileInfoRequestSchema;
    output: typeof ProfileInfoResponseSchema;
  };
  /**
   * @generated from rpc UserData.GetProfileInfo
   */
  getProfileInfo: {
    methodKind: 'unary';
    input: typeof GetProfileInfoRequestSchema;
    output: typeof ProfileInfoResponseSchema;
  };
  /**
   * @generated from rpc UserData.UpdateProfileInfo
   */
  updateProfileInfo: {
    methodKind: 'unary';
    input: typeof UpdateProfileInfoRequestSchema;
    output: typeof ProfileInfoResponseSchema;
  };
  /**
   * @generated from rpc UserData.AddAddress
   */
  addAddress: {
    methodKind: 'unary';
    input: typeof AddressRequestSchema;
    output: typeof AddressResponseSchema;
  };
  /**
   * @generated from rpc UserData.GetAddresses
   */
  getAddresses: {
    methodKind: 'unary';
    input: typeof EmptySchema;
    output: typeof GetAddressesResponseSchema;
  };
  /**
   * @generated from rpc UserData.UpdateAddress
   */
  updateAddress: {
    methodKind: 'unary';
    input: typeof AddressRequestSchema;
    output: typeof AddressResponseSchema;
  };
  /**
   * @generated from rpc UserData.AddUserEducation
   */
  addUserEducation: {
    methodKind: 'unary';
    input: typeof AddUserEducationRequestSchema;
    output: typeof UserEducationResponseSchema;
  };
  /**
   * @generated from rpc UserData.UpdateUserEducation
   */
  updateUserEducation: {
    methodKind: 'unary';
    input: typeof UpdateUserEducationRequestSchema;
    output: typeof UserEducationResponseSchema;
  };
  /**
   * @generated from rpc UserData.DeleteUserEducation
   */
  deleteUserEducation: {
    methodKind: 'unary';
    input: typeof DeleteUserEducationRequestSchema;
    output: typeof GenericResponseSchema;
  };
  /**
   * @generated from rpc UserData.GetUserEducations
   */
  getUserEducations: {
    methodKind: 'unary';
    input: typeof EmptySchema;
    output: typeof UserEducationResponseSchema;
  };
  /**
   * @generated from rpc UserData.UploadProfileImage
   */
  uploadProfileImage: {
    methodKind: 'unary';
    input: typeof UploadProfileImageRequestSchema;
    output: typeof UploadProfileImageResponseSchema;
  };
  /**
   * @generated from rpc UserData.AddAprendeUserInfo
   */
  addAprendeUserInfo: {
    methodKind: 'unary';
    input: typeof AprendePersonRequestSchema;
    output: typeof ProfileInfoResponseSchema;
  };
  /**
   * @generated from rpc UserData.AddUserEmployment
   */
  addUserEmployment: {
    methodKind: 'unary';
    input: typeof AddUserEmploymentRequestSchema;
    output: typeof UserEmploymentResponseSchema;
  };
  /**
   * @generated from rpc UserData.UpdateUserEmployment
   */
  updateUserEmployment: {
    methodKind: 'unary';
    input: typeof UpdateUserEmploymentRequestSchema;
    output: typeof UserEmploymentResponseSchema;
  };
  /**
   * @generated from rpc UserData.DeleteUserEmployment
   */
  deleteUserEmployment: {
    methodKind: 'unary';
    input: typeof DeleteUserEmploymentRequestSchema;
    output: typeof GenericResponseSchema;
  };
  /**
   * @generated from rpc UserData.GetUserEmployments
   */
  getUserEmployments: {
    methodKind: 'unary';
    input: typeof EmptySchema;
    output: typeof UserEmploymentResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_src_protos_users_users, 0);
